import { render, staticRenderFns } from "./DepositeChannel.vue?vue&type=template&id=2beb37e4&scoped=true"
import script from "./DepositeChannel.vue?vue&type=script&lang=js"
export * from "./DepositeChannel.vue?vue&type=script&lang=js"
import style0 from "./DepositeChannel.vue?vue&type=style&index=0&id=2beb37e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb37e4",
  null
  
)

export default component.exports